import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Airtable from 'airtable';
import Avatar from './Avatar';
import AvatarInfoHolder from './AvatarInfoHolder';

const Holder = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 2rem;
  grid-row-gap: 2rem;
  margin-top: 4rem;
`;

function Collection( { avatarPrefix, participantage, participantoccupation, participantlocation, workshop, showInfo, limit } ) {
  const [ avatars, setAvatars ] = useState( [] );
  const [ noResults, setNoResults ] = useState( [ false ] );
  const [ firstInWorkshop, setFirstInWorkshop ] = useState( [ false ] );
  const [ loading, setLoading ] = useState( [ true ] );

  const setFormula = ( prefix, age, occupation, location, workshop ) => {
    let strings = [ `{prefix} = '${prefix}'` ];
    if ( age && age !== 'all' ) { strings.push( `{participantage} = '${age}'` ) }
    if ( occupation && occupation !== 'all' ) { strings.push( `{participantoccupation} = '${occupation}'` ) }
    if ( location && location !== 'all' ) { strings.push( `{participantlocation} = '${location}'` ) }
    if ( workshop ) { strings.push( `{workshop}` ) }
    return strings.join( ', ' );
  };

  useEffect( () => {
    setLoading( true );
    const base = new Airtable( { apiKey: `${process.env.REACT_APP_AIRTABLE_API_KEY}` } ).base( 'appJ4XWmflOm4QY2P' );
    base( 'User responses' ).select( {
      // Selecting the first 3 records in Grid view:
      maxRecords: limit,
      view: 'Grid view',
      filterByFormula: `AND(${setFormula( avatarPrefix, participantage, participantoccupation, participantlocation, workshop )})`,
    } ).eachPage( function page( records, fetchNextPage ) {
      // This function (`page`) will get called for each page of records.

      if ( records.length > 0 ) {
        records.forEach( function ( record ) {
          console.log( 'Retrieved', record.getId() );
        } );
        setAvatars( records );
        setFirstInWorkshop( false );
        setNoResults( false );
      } else if ( workshop ) {
        setFirstInWorkshop( true );
        setNoResults( true );
      } else {
        setNoResults( true );
      }

      setLoading( false );
      // To fetch the next page of records, call `fetchNextPage`.
      // If there are more records, `page` will get called again.
      // If there are no more records, `done` will get called.
      fetchNextPage();

    }, function done( err ) {
      if ( err ) {
        console.error( err );
        setLoading( false );
        setNoResults( true );
      }
    } );
  }, [ avatarPrefix, participantage, participantoccupation, participantlocation, workshop, limit ] );


  if ( loading ) { return (<p>Loading...</p>) }
  if ( firstInWorkshop ) { return (
    <p>Looks like you are the first person in your workshop to complete this exercise! Wait for the
      others to finish and then refresh... or plough on!</p>)
  }
  if ( noResults ) { return (<p>No results for that combination of participant attributes.</p>) }

  return (
    <Holder>{avatars.map( avatar => (
      <AvatarInfoHolder key={avatar.getId()} showInfo={showInfo} details={avatar.fields}>
        <Avatar currentAvatar={avatar.fields.prefix} features={avatar.fields}/>
      </AvatarInfoHolder>
    ) )}</Holder>
  )
}

Collection.propTypes = {
  avatarPrefix: PropTypes.string.isRequired,
  participantage: PropTypes.string,
  participantoccupation: PropTypes.string,
  participantlocation: PropTypes.string,
  workshop: PropTypes.bool,
  showInfo: PropTypes.bool,
  limit: PropTypes.number,
};

Collection.defaultProps = {
  workshop: false,
  limit: 20
};

export default Collection;
